import { render, staticRenderFns } from "./zoomed-image-component.vue?vue&type=template&id=1bf542f6&scoped=true&"
import script from "./zoomed-image-component.vue?vue&type=script&lang=ts&"
export * from "./zoomed-image-component.vue?vue&type=script&lang=ts&"
import style0 from "./zoomed-image-component.vue?vue&type=style&index=0&id=1bf542f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf542f6",
  null
  
)

export default component.exports